<template>
  <template v-if="mapOptions?.length > 0 && aoiData.bbox != null">
    <!-- outside container height: 100%, in smaller screen map will stacked-->
    <div class="columns compare-map is-centered" :class="'compare-map' + mapConfig.length" style="position: relative; width: 100%; height: 100%;">
      <template v-for="(map, index) in mapOptions" :key="'map' + index">
        <div class="column is-4-tablet">
          <h3 class="has-text-centered mb-1">{{  map.title }}</h3>
          <div class="mapbox-container" style="position: relative; height: 600px;">
          <simple-map :ref="'map' + index" @init="editorInit($event, index)"  :map-div-id="mapId + index" :map-config="map.config"
            :map-layers="map.mapLayers" :aoi-data="aoiData"
            :widthPct="100"
            :height="600" :isSingleMap="false"/>
          </div>
        </div>
      </template>
    <!-- <div class="column mapbox-container" >
      <simple-map ref="leftMap" @init="editorInit($event, 'left')"  :map-div-id="'left' + mapId" :map-config="leftMapOption.config"
        :map-layers="leftMapOption.mapLayers" :aoi-data="aoiData"
        :map-title="leftMapTitle"
        :map-title-class="right"
        :widthPct="45"
        :height="600" :isSingleMap="false"/>
    </div>
    <div class="column mapbox-container"  >
      <simple-map ref="rightMap" @init="editorInit($event, 'right')" :map-div-id="'right' + mapId" :map-config="rightMapOption.config"
        :map-layers="rightMapOption.mapLayers" :aoi-data="aoiData"
        :map-title="rightMapTitle"
        :map-title-class="'right'"
        :widthPct="45"
        :height="600" :isSingleMap="false"/>
    </div>
    <div class="column mapbox-container"  >
      <simple-map ref="rightMap" @init="editorInit($event, 'right')" :map-div-id="'right' + mapId" :map-config="rightMapOption.config"
        :map-layers="rightMapOption.mapLayers" :aoi-data="aoiData"
        :map-title="rightMapTitle"
        :map-title-class="'right'"
        :widthPct="45"
        :height="600" :isSingleMap="false"/>
    </div> -->
    </div>
  </template>
</template>

<script>
import { reactive, ref } from 'vue';
import { useApp } from '@/composables/state/profileState';
import StandardMap from './StandardMap.vue'
// import AlbertaCompareMapText from './AlbertaCompareMapText.vue'
import 'mapbox-gl-compare/style.css'; // get styles
import syncMaps from '@mapbox/mapbox-gl-sync-move'

/*
  Note:
    don't show legend at compare map, as the custom legend is at map div level not inside, which
    interferes with  the compare display.
*/
export default {
  name: 'alberta-compare-map',
  components: {
    'simple-map': StandardMap
  },
  props: ['mapConfig'],
  setup (props) {
    const { mapLayers, aoiData, currentTab } = useApp();
    const isDataReady = ref(false);
    const mapLink = ref({});
    const mapId = 'map' + Date.now();
    // const leftMapOption = reactive({});
    // const rightMapOption = reactive({});
    const mapOptions = reactive([]);
    const mapObj = reactive([]); // acutal js map instance, can use it to control map (zoom, move etc)
    const compareMap = reactive({});
    const loadData = async () => {
      if (!isDataReady.value && mapLayers.length > 0) {
        mapLink.value.aoi = aoiData.aoiId;
        mapLink.value.dataSet = [];

        props.mapConfig.forEach((map, index) => {
          const layerId = mapLayers.filter(x => map.name?.includes(x.name)).map(x => { return { mapId: x.id + '', toShow: true }; });
          if (layerId) {
            layerId.forEach(x => { mapLink.value.dataSet.push(x.mapId); });
            mapOptions.push({
              title: map.title,
              config: { showLegend: false, mapCategory: map.name, allowHideLayer: false, showMapControl: index === props.mapConfig.length - 1 },
              mapLayers: layerId
            });
          }
        })
      }
    }

    // const loadData = async () => {
    //   if (!isDataReady.value && mapLayers.length > 0) {
    //     const leftLayerIds = mapLayers.filter(x => props.leftLayerNames?.includes(x.name)).map(x => { return { mapId: x.id + '', toShow: true }; });
    //     if (leftLayerIds) {
    //       Object.assign(leftMapOption, {
    //         config: { showLegend: false, mapCategory: 'leftmapCategory', allowHideLayer: false, showMapControl: true },
    //         mapLayers: leftLayerIds
    //       });
    //     }
    //     const rightLayerIds = mapLayers.filter(x => props.rightLayerNames?.includes(x.name)).map(x => { return { mapId: x.id + '', toShow: true }; });
    //     if (rightLayerIds) {
    //       Object.assign(rightMapOption, {
    //         config: { showLegend: false, mapCategory: 'rightmapCategory', allowHideLayer: false, showMapControl: true },
    //         mapLayers: rightLayerIds
    //       });
    //       isDataReady.value = true;
    //     }
    //   }
    // };
    /*
      issue with watching array (tried deep, update contents, and replace objects), all didn't triger the watch.
      So for this case (array will be loaded only once, and will never be changed), I use the maplayer array size to check.
      TODO:  Still need to work out in general cases, how to watch array.
    */
    // watch(() => mapLayers.length, async (newVal, oldVal) => {
    //   if (newVal) {
    //     loadData();
    //   }
    // });

    const editorInit = (map, index) => {
      mapObj[index] = map;
      if (mapObj.length === props.mapConfig.length) {
        // const container = `#mapCompare-${mapId}`;
        // compareMap.map = new MapboxCompare(mapObj.left, mapObj.right, container, {});
        // // Set Position - this will set the slider at the specified (x) number of pixels from the left-edge or top-edge of viewport based on swiper orientation
        // compareMap.map.setSlider(compareMap.map.currentPosition + 50);
        // console.log({ mapObj }, 'sync');
        syncMaps(mapObj);
      }
    }
    /*
      issue with watching array (tried deep, update contents, and replace objects), all didn't triger the watch.
      So for this case (array will be loaded only once, and will never be changed), I use the maplayer array size to check.
      TODO:  Still need to work out in general cases, how to watch array.
    */
    // watch(() => mapLayers.length, async (newVal, oldVal) => {
    //   if (newVal) {
    //     loadData();
    //   }
    // });

    return {
      mapId,
      mapLayers,
      mapLink,
      aoiData,
      isDataReady,
      loadData,
      editorInit,
      currentTab,
      compareMap,
      mapOptions
    }
  },

  created () {
    this.loadData();
  },

  watch: {
    mapLayers: {
      handler (val, oldVal) {
        this.loadData();
      },
      deep: true
    },
    currentTab: {
      /* use this the refresh map, as the initally hidden maps don't have a proper size (although size were assigned, but on windows it was hidden so size was not right)
      */
      handler (val, oldVal) {
        this.$nextTick(function () {
          this.mapObj?.forEach(x => x.redraw());
          // Code that will run only after the
          // entire view has been re-rendered
          // this.$refs.leftMap && this.$refs.leftMap.redraw();
          // this.$refs.rightMap && this.$refs.rightMap.redraw();

          // if (this.compareMap?.map) {
          //   /* always put slider in the middle
          //   without this step, the slide will be outside of the map container and make map invisible
          //   */
          //   const width = this.compareMap.map?._bounds?.width || 200;
          //   this.compareMap.map.setSlider(0.5 * width);
          // }
        })
      }
    }
  }
}
</script>

<style scoped>
div ::v-deep(.compare-map) {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}

.compare-map-container.mapbox-container ::v-deep(.mapboxgl-compare) {
  background-color: #9e9e9e;
  top: 0;
}

div ::v-deep(.custom-controller) {
  right: -60px;
}
</style>
